import React from "react";
import { SimpleProduct } from "../../shared/types";

interface ProductSelectProps {
  simpleProducts: SimpleProduct[];
  selectedProductIndex: number | null;
  onProductChange: (index: number) => void;
  currency?: string;
}

const ProductSelect: React.FC<ProductSelectProps> = ({
  simpleProducts,
  selectedProductIndex,
  onProductChange,
  currency,
}) => {
  return (
    <div>
      {simpleProducts.map((simpleProduct, index) => (
        <div key={index}>
          <div className="overflow-hidden rounded-lg bg-white shadow mb-4">
            <div className="px-4 py-4 sm:px-6 flex items-center justify-between">
              <input
                type="radio"
                name="product"
                className="h-4 w-4 rounded border-gray-300 text-black focus:ring-slate-600 mr-2"
                checked={selectedProductIndex === index}
                onChange={() => onProductChange(index)}
              />
              <span className="text-lg flex-grow">{simpleProduct.name}</span>
              <div className="font-semibold">
                {currency}
                {simpleProduct.price.toFixed(2)}
              </div>
            </div>
            {simpleProduct.description ? (
              <div className="flex flex-col md:flex-row p-4">
                <div>
                  {simpleProduct.headline && (
                    <h4 className="text-lg font-bold">
                      {simpleProduct.headline}
                    </h4>
                  )}
                  <p className="mt-1">{simpleProduct.description}</p>
                </div>
                {simpleProduct.affirm && <div>Affirm Available</div>}
              </div>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductSelect;
